import * as config from './uiConfig';
import { Script } from 'src/replicant/conversation/conservation.ruleset';
import { Widen } from 'src/replicant/utils/types';
import StateObserver from 'src/StateObserver';
import { Conversation } from 'src/replicant/conversation';
import PopupSpeechBubbleBase, {
  SpeechBubbleCloseHandler,
} from './PopupSpeechBubbleBase';
import { View } from '@play-co/timestep-core/ui';
import platform from '@play-co/gcinstant';
import { getPlayerIdFromConversation } from 'src/game/conversation/conversation.redux';

export default class PopupConversationScript extends PopupSpeechBubbleBase<void> {
  constructor(opts: {
    superview: View;
    close: SpeechBubbleCloseHandler<void>;
  }) {
    super({ ...opts, $subFeature: 'script', closeAfterSkip: true });
  }

  public init({ id, move_to }: Pick<Widen<Script>, 'id' | 'move_to'>) {
    const { user, ui } = StateObserver.getState();

    const message = Conversation.getters(user).getScriptText(
      id,
      ui.locale,
      getPlayerIdFromConversation(id) !== platform.playerID,
    );

    // If the message somehow ends up being undefined, replace it by '...' to prevent
    // a big "undefined" text showing up in the speech bubble.
    const fallback = '...';

    super.init({
      id,
      move_to,
      message: message || fallback,
    });
  }
}
